import type { AxiosRequestConfig } from 'axios';
import type {
  DownloadedPlugins,
  InstalledPlugins,
} from '@/entities/system/plugin';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

export class PluginsApi {
  static getDownloadedPluginsList(options: AxiosRequestConfig = {}) {
    return srmInstance.get<DownloadedPlugins[]>(`/plugins`, options);
  }

  static getInstalledPluginsList(options: AxiosRequestConfig = {}) {
    return srmInstance.get<InstalledPlugins[]>(`/plugins/installed`, options);
  }

  static updloadPlugin(payload: FormData, options: AxiosRequestConfig = {}) {
    return srmInstance.post<any>(`/plugins/upload`, payload, options);
  }

  static downloadPlugin(plugin_name: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/plugins/${plugin_name}`, {
      responseType: 'blob',
      ...options,
    });
  }

  static installPlugin(
    plugin_name: string,
    force?: boolean,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<boolean>(`/plugins/${plugin_name}/install`, null, {
      ...options,
      params: {
        force,
      },
    });
  }

  static installPluginOnRunner(
    plugins: string[],
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<string[]>(
      `/plugins/install/runners`,
      plugins,
      options,
    );
  }

  static deinstallPlugin(
    plugin_name: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.delete<string>(
      `/plugins/installed/${plugin_name}`,
      options,
    );
  }

  static deletePlugin(plugin_name: string, options: AxiosRequestConfig = {}) {
    return srmInstance.delete<string>(`/plugins/${plugin_name}`, options);
  }
}